import { Button } from 'react-bootstrap'
import styled from 'styled-components'

export const CardSection = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 32px 28px;
  margin-bottom: 24px;
`

export const InfoCard = styled.div`
  background: #fff;
  border-radius: 8px;
  border-left: 4px solid #0072bc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px 24px;
  margin-bottom: 24px;

  h4 {
    font-size: 0.875rem;
    font-weight: 600;
    color: #222;
    margin: 0 0 12px 0;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    color: #495057;
    font-size: 0.875rem;
    line-height: 1.6;
  }
`

export const AddSectionButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 20px;
  background: #f0f9ff;
  border: 1px dashed #0072bc;
  border-radius: 8px;
  color: #0072bc;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 24px;
  transition: background 0.2s ease;

  &:hover {
    background: #e0f2fe;
  }
`

export const AccordionCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  overflow: hidden;
`

export const AccordionHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f8f9fa;
  }

  &:focus-visible {
    outline: 2px solid #0072bc;
    outline-offset: -2px;
  }
`

export const AccordionHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0072bc;
  font-weight: 600;
  font-size: 0.95rem;
`

export const AccordionHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const AccordionChevron = styled.span<{ open: boolean }>`
  display: inline-flex;
  align-items: center;
  color: #0072bc;
  transition: transform 0.2s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const AccordionBody = styled.div`
  padding: 0 20px 20px 20px;
`

export const SectionFieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const SectionField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 4px;
  display: block;
`

export const RequiredMark = styled.span`
  color: #dc3545;
  margin-left: 2px;
`

export const CheckboxGroup = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 8px;

  .form-check {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
  }

  .form-check-label {
    font-size: 0.875rem;
    color: #222;
    cursor: pointer;
  }
`

export const QuestionCard = styled.div`
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 12px;
`

export const QuestionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  cursor: pointer;

  span {
    color: #0072bc;
    font-weight: 600;
    font-size: 0.9rem;
  }
`

export const QuestionHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0072bc;
  font-weight: 600;
  font-size: 0.9rem;
`

export const QuestionHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const QuestionChevron = styled.span<{ open: boolean }>`
  display: inline-flex;
  align-items: center;
  color: #0072bc;
  transition: transform 0.2s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const QuestionBody = styled.div`
  padding-top: 8px;
`

export const QuestionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  margin-bottom: 12px;
  align-items: flex-end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const QuestionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`

export const AddQuestionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: #0072bc;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    text-decoration: underline;
  }
`

export const AddDescriptionLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: transparent;
  border: none;
  color: #0072bc;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 8px;

  &:hover {
    text-decoration: underline;
  }
`

export const AddOptionLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: transparent;
  border: none;
  color: #0072bc;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 12px;

  &:hover {
    text-decoration: underline;
  }
`

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;

  .form-check {
    padding-left: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .form-check-input {
    margin-left: 0;
    float: none;
    width: 36px;
    height: 20px;
    cursor: pointer;
  }

  .form-check-label {
    cursor: pointer;
    font-weight: 500;
    font-size: 0.875rem;
    color: #222;
  }
`

export const DeleteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #dc3545;
  font-size: 1rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background: rgba(220, 53, 69, 0.1);
  }
`

export const RemoveSectionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #dc3545;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background: rgba(220, 53, 69, 0.1);
  }
`

export const FormInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #212529;
  background: #fff;

  &:focus {
    outline: none;
    border-color: #0072bc;
    box-shadow: 0 0 0 3px rgba(0, 114, 188, 0.15);
  }

  &::placeholder {
    color: #adb5bd;
  }
`

export const FormSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #212529;
  background: #fff;
  min-width: 140px;

  &:focus {
    outline: none;
    border-color: #0072bc;
    box-shadow: 0 0 0 3px rgba(0, 114, 188, 0.15);
  }
`

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #212529;
  background: #fff;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: #0072bc;
    box-shadow: 0 0 0 3px rgba(0, 114, 188, 0.15);
  }
`
export const RemoveButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`

export const RemoveButton = styled(Button)`
  background: transparent;
  border: 1px solid #0072bc;
  border-radius: 4px;
  color: #0072bc;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.85rem;
  padding: 0;

  &:hover {
    background: rgba(0, 114, 188, 0.08);
  }
`

export const AddCustomSectionButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 20px;
  background: #cce5f5;
  border: 1px solid #0072bc;
  border-radius: 8px;
  color: #0072bc;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s ease;

  &:hover {
    background: #b8dcef;
  }
`

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
`

export const OptionRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;

  > div:first-child {
    flex: 1;
  }
`

export const OptionRemoveButton = styled.button`
  background: transparent;
  border: none;
  color: #dc3545;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;

  &:hover {
    background: rgba(220, 53, 69, 0.1);
  }
`
